import { jwtDecode } from "jwt-decode";
import { useSelector } from "react-redux";

export const getRoleFromToken = (token) => {
  try {
    if (!token) return null;
    const decoded = jwtDecode(token);
    console.log(decoded)
    return decoded.role;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};
